import { useEffect } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, ArrowLeft } from "lucide-react";

const ThankYou = () => {
  useEffect(() => {
    document.title = "\u00a1Gracias! \u2014 Ecominarg";
    document.documentElement.setAttribute("lang", "es-AR");
  }, []);

  return (
    <main className="min-h-[80vh] bg-gradient-to-b from-[#f6f4ef] to-white flex items-center">
      <div className="max-w-3xl mx-auto px-5 lg:px-8 py-20 text-center">
        <span className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-[#0b2545] text-white shadow-lg shadow-[#0b2545]/20">
          <CheckCircle2 className="w-10 h-10" strokeWidth={2} />
        </span>
        <h1 className="mt-8 text-4xl sm:text-5xl font-extrabold tracking-tight text-[#0b2545]">
          ¡Gracias por su consulta!
        </h1>
        <p className="mt-4 text-base sm:text-lg text-[#0b2545]/78 leading-relaxed">
          Hemos recibido su mensaje. Nuestro equipo de análisis lo contactará dentro de las próximas 48 horas hábiles desde Buenos Aires.
        </p>
        <div className="mt-10">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3.5 rounded-full bg-[#0b2545] text-white font-semibold text-sm hover:bg-[#13315c] transition shadow-lg shadow-[#0b2545]/15"
            data-testid="thankyou-back-home"
          >
            <ArrowLeft className="w-4 h-4" /> Volver al inicio
          </Link>
        </div>
      </div>
    </main>
  );
};

export default ThankYou;
